import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function TermsModal({
  isOpen,
  onClose
}: ModalProps) {
  return <AnimatePresence data-id="element-115">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-espresso/80 backdrop-blur-sm z-[100]" data-id="element-116" />
          <motion.div initial={{
        opacity: 0,
        y: 50,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="fixed inset-0 z-[101] flex items-center justify-center p-4 md:p-6 pointer-events-none" data-id="element-117">
            <div className="bg-warm-white w-full max-w-3xl max-h-[85vh] overflow-hidden shadow-2xl flex flex-col pointer-events-auto border-t-4 border-terracotta" data-id="element-118">
              <div className="flex justify-between items-center p-6 border-b border-beige bg-cream" data-id="element-119">
                <h2 className="font-serif text-2xl font-bold text-espresso" data-id="element-120">
                  Términos y Condiciones
                </h2>
                <button onClick={onClose} className="p-2 text-espresso/60 hover:text-terracotta transition-colors rounded-full hover:bg-beige/50" data-id="element-121">
                  <X size={24} data-id="element-122" />
                </button>
              </div>

              <div className="p-6 md:p-8 overflow-y-auto text-espresso/80 space-y-6 text-sm md:text-base leading-relaxed" data-id="element-123">
                <p data-id="element-124">
                  Última actualización:{' '}
                  {new Date().toLocaleDateString('es-ES', {
                month: 'long',
                year: 'numeric'
              })}
                </p>

                <div data-id="element-125">
                  <h3 className="font-serif text-lg font-bold text-espresso mb-2" data-id="element-126">
                    1. Producto Digital
                  </h3>
                  <p data-id="element-127">
                    El ebook "Masa Pan: Lo que la Panadería no te cuenta" es un
                    producto digital en formato PDF. Al realizar la compra,
                    obtienes acceso inmediato para su descarga a través de la
                    plataforma The Assets Vault.
                  </p>
                </div>

                <div data-id="element-128">
                  <h3 className="font-serif text-lg font-bold text-espresso mb-2" data-id="element-129">
                    2. Política de Reembolso
                  </h3>
                  <p data-id="element-130">
                    Debido a la naturaleza digital del producto y su acceso
                    inmediato, todas las ventas son finales. No se ofrecen
                    reembolsos una vez que el archivo ha sido descargado o
                    accedido.
                  </p>
                </div>

                <div data-id="element-131">
                  <h3 className="font-serif text-lg font-bold text-espresso mb-2" data-id="element-132">
                    3. Propiedad Intelectual y Uso Permitido
                  </h3>
                  <p data-id="element-133">
                    El contenido de este ebook (textos, recetas, fotografías y
                    diseño) está protegido por derechos de autor. La compra te
                    otorga una licencia de uso personal y no transferible.
                  </p>
                  <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-134">
                    <li data-id="element-135">
                      <strong data-id="element-136">Permitido:</strong> Usar las recetas para hornear
                      pan para consumo personal o para vender el pan físico
                      resultante de estas recetas.
                    </li>
                    <li data-id="element-137">
                      <strong data-id="element-138">No Permitido:</strong> Revender, redistribuir,
                      copiar, compartir o publicar el contenido del ebook (PDF,
                      textos o imágenes) en cualquier formato físico o digital.
                    </li>
                  </ul>
                </div>

                <div data-id="element-139">
                  <h3 className="font-serif text-lg font-bold text-espresso mb-2" data-id="element-140">
                    4. Soporte
                  </h3>
                  <p data-id="element-141">
                    Con tu compra, tienes derecho a 7 días de soporte vía correo
                    electrónico para resolver dudas específicas sobre las
                    recetas o el proceso de horneado. El correo de contacto se
                    proporcionará junto con la entrega del ebook.
                  </p>
                </div>

                <div data-id="element-142">
                  <h3 className="font-serif text-lg font-bold text-espresso mb-2" data-id="element-143">
                    5. Resultados
                  </h3>
                  <p data-id="element-144">
                    Los resultados de las recetas pueden variar dependiendo de
                    factores externos como el clima, la calidad de los
                    ingredientes, el tipo de horno y la ejecución de la técnica.
                    Masa Pan proporciona las fórmulas exactas, pero no garantiza
                    resultados idénticos a las fotografías.
                  </p>
                </div>
              </div>

              <div className="p-4 border-t border-beige bg-cream text-center" data-id="element-145">
                <button onClick={onClose} className="bg-espresso text-cream px-8 py-3 font-medium hover:bg-terracotta transition-colors" data-id="element-146">
                  Entendido
                </button>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}
export function PrivacyModal({
  isOpen,
  onClose
}: ModalProps) {
  return <AnimatePresence data-id="element-147">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-espresso/80 backdrop-blur-sm z-[100]" data-id="element-148" />
          <motion.div initial={{
        opacity: 0,
        y: 50,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="fixed inset-0 z-[101] flex items-center justify-center p-4 md:p-6 pointer-events-none" data-id="element-149">
            <div className="bg-warm-white w-full max-w-3xl max-h-[85vh] overflow-hidden shadow-2xl flex flex-col pointer-events-auto border-t-4 border-terracotta" data-id="element-150">
              <div className="flex justify-between items-center p-6 border-b border-beige bg-cream" data-id="element-151">
                <h2 className="font-serif text-2xl font-bold text-espresso" data-id="element-152">
                  Política de Privacidad
                </h2>
                <button onClick={onClose} className="p-2 text-espresso/60 hover:text-terracotta transition-colors rounded-full hover:bg-beige/50" data-id="element-153">
                  <X size={24} data-id="element-154" />
                </button>
              </div>

              <div className="p-6 md:p-8 overflow-y-auto text-espresso/80 space-y-6 text-sm md:text-base leading-relaxed" data-id="element-155">
                <p data-id="element-156">
                  Última actualización:{' '}
                  {new Date().toLocaleDateString('es-ES', {
                month: 'long',
                year: 'numeric'
              })}
                </p>

                <div data-id="element-157">
                  <h3 className="font-serif text-lg font-bold text-espresso mb-2" data-id="element-158">
                    1. Información que Recopilamos
                  </h3>
                  <p data-id="element-159">
                    Al realizar una compra en nuestra landing page (procesada a
                    través de The Assets Vault), recopilamos la información
                    necesaria para procesar tu pedido y entregar el producto
                    digital. Esto incluye:
                  </p>
                  <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-160">
                    <li data-id="element-161">Nombre completo</li>
                    <li data-id="element-162">Dirección de correo electrónico</li>
                    <li data-id="element-163">
                      Información de pago (procesada de forma segura por nuestra
                      pasarela de pagos; nosotros no almacenamos datos de
                      tarjetas de crédito)
                    </li>
                  </ul>
                </div>

                <div data-id="element-164">
                  <h3 className="font-serif text-lg font-bold text-espresso mb-2" data-id="element-165">
                    2. Uso de la Información
                  </h3>
                  <p data-id="element-166">Utilizamos tus datos personales exclusivamente para:</p>
                  <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-167">
                    <li data-id="element-168">Entregar el ebook digital a tu correo electrónico.</li>
                    <li data-id="element-169">
                      Proporcionar el soporte de 7 días incluido con tu compra.
                    </li>
                    <li data-id="element-170">
                      Enviar actualizaciones importantes sobre el producto (si
                      aplica).
                    </li>
                    <li data-id="element-171">Cumplir con obligaciones legales y fiscales.</li>
                  </ul>
                </div>

                <div data-id="element-172">
                  <h3 className="font-serif text-lg font-bold text-espresso mb-2" data-id="element-173">
                    3. Protección y Compartición de Datos
                  </h3>
                  <p data-id="element-174">
                    Respetamos tu privacidad. No vendemos, alquilamos ni
                    compartimos tu información personal con terceros para fines
                    de marketing. Tus datos solo se comparten con los
                    proveedores de servicios estrictamente necesarios para
                    operar nuestro negocio (como The Assets Vault y pasarelas de
                    pago).
                  </p>
                </div>

                <div data-id="element-175">
                  <h3 className="font-serif text-lg font-bold text-espresso mb-2" data-id="element-176">
                    4. Cookies y Tecnologías de Seguimiento
                  </h3>
                  <p data-id="element-177">
                    Esta landing page utiliza cookies básicas estrictamente
                    necesarias para el funcionamiento del sitio y para analizar
                    el tráfico de forma anónima, con el fin de mejorar la
                    experiencia del usuario.
                  </p>
                </div>

                <div data-id="element-178">
                  <h3 className="font-serif text-lg font-bold text-espresso mb-2" data-id="element-179">
                    5. Tus Derechos
                  </h3>
                  <p data-id="element-180">
                    Tienes derecho a solicitar el acceso, rectificación o
                    eliminación de tus datos personales en cualquier momento.
                    Para ejercer estos derechos o si tienes alguna pregunta
                    sobre nuestra política de privacidad, puedes contactarnos
                    respondiendo al correo de confirmación de tu compra.
                  </p>
                </div>
              </div>

              <div className="p-4 border-t border-beige bg-cream text-center" data-id="element-181">
                <button onClick={onClose} className="bg-espresso text-cream px-8 py-3 font-medium hover:bg-terracotta transition-colors" data-id="element-182">
                  Entendido
                </button>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}